module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-1-edd4b88c918a95e3e50b8bcef442e28c.png";